<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card v-else-if="!this.loading && !this.errormessage">
      <el-table
        :data="rowData"
        header-row-class-name="text-danger"
        size="small"
        :stripe="striped"
        :header-cell-style="headerCellStyle"
        :default-sort="sorting"
        :cell-style="cellStyle"
        height="197"
        v-if="rowData.length > 0"
      >
        <el-table-column
          label="Patrol"
          :sort-method="sortPatrol"
          sortable
          property="Critter"
        />
        <el-table-column
          label="Name"
          property="FullName"
        />
        <el-table-column
          label="Age"
          property="Age"
          class-name="text-center"
        />
        <el-table-column
          label="District"
          property="District"
          class-name="text-center"
        />
        <el-table-column
          label="Tenure"
          property="YearsScoutingAdult"
          class-name="text-center"
        />
        <el-table-column
          label="Program"
          property="ProgramName"
          class-name="text-center"
        />
        <el-table-column
          label="Needs"
          property="SpecialNeeds"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="center"
          width="80"
          label="Assign"
        >
          <template slot-scope="props">
            <p-button
              type="success"
              class="m-1"
              size="sm"
              title="Assign Patrol"
              icon
              @click="assign(props.row)"
            >
              <i class="nc-icon nc-bus-front-12" />
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </card>
    <card v-if="rawInfo">
      <el-table
        class="mt-2"
        :data="rawInfo.Statistics"
        header-row-class-name="text-danger text-center"
        cell-class-name="text-center"
        size="small"
        :header-cell-style="statsHeaderCellStyle"
        :row-class-name="rowStyle"
        :cell-style="cellStyle"
      >
        <el-table-column
          label="Patrol"
          property="CritterName"
        />
        <el-table-column
          label="Total"
          property="TotalCount"
          class-name="border-right"
        />
        <el-table-column
          label="Tenure"
          class-name="border-bottom"
        >
          <el-table-column
            class-name="d-none d-md-table-cell"
            label="Min"
            property="MinYears"
          />
          <el-table-column
            class-name="d-none d-md-table-cell"
            label="Max"
            property="MaxYears"
          />
          <el-table-column
            label="Avg"
            :formatter="avgFormatter"
            property="AvgYears"
          />
        </el-table-column>
        <el-table-column
          label="Program Mix"
          class-name="border-bottom border-left mix-header"
        >
          <el-table-column
            label="Cub Scouts"
            property="CubScouting"
            class-name="border-left"
          />
          <el-table-column
            label="Scouts BSA"
            property="ScoutsBSA"
          />
          <el-table-column
            label="Venturing"
            property="Venturing"
          />
          <el-table-column
            label="Sea Scouts"
            property="SeaScouting"
          />
          <el-table-column
            label="Exploring"
            property="Exploring"
          />
          <el-table-column
            label="District"
            property="District"
          />
          <el-table-column
            label="Council"
            property="Council"
          />
          <el-table-column
            label="Other"
            property="Other"
          />
        </el-table-column>
      </el-table>
    </card>
    <modal
      :show.sync="showEdit"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      type="mini"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6><i class="nc-icon nc-bus-front-12 mr-2" /><span class="text-danger">Assign Participant to Patrol</span></h6>
      </div>
      <ValidationObserver ref="form">
        <form @submit.prevent="save">
          <div class="row">
            <div class="col-12">
              <ValidationProvider
                name="fullName"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <fg-input>
                  <label>Please select Patrol Assignment</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    :error="failed ? 'Please select a patrol': null"
                    :has-success="passed"
                    name="patrol"
                    placeholder=""
                    v-model="critterUpdate.Critter"
                  >
                    <el-option
                      v-for="option in critters"
                      class="select-default2"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    />
                  </el-select>
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showEdit = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          @click="save"
        >
          Save
        </p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import oops from '@/components/_main/oops.vue'
import patrolApi from '@/services/api/patrol'
import crittersService from '@/services/static/critters'
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'PatrolsEdit',
  components: {
    oops,
    Modal
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '40px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'text-align': 'center', 'overflow-wrap': 'break-word' },
      statsHeaderCellStyle: { padding: '0', height: '20px', 'font-size': '8px', 'text-align': 'center' },
      sorting: { prop: 'Critter', order: 'descending' },
      loading: true,
      errormessage: null,
      critters: null,
      critterUpdate: {},
      showEdit: false,
      rowData: null,
      patrolCounts: null,
      programStats: null,
      tenureStats: null,
      rawInfo: null,
      striped: true,
      tempHolding: [],
      statsFields: [
        {
          key: 'CritterName',
          label: 'Patrol',
          class: 'border-right'
        },
        {
          key: 'TotalCount',
          label: 'Total',
          class: 'border-right text-center'
        },
        {
          key: 'MinYears',
          label: 'Min',
          class: 'text-center'
        },
        {
          key: 'MaxYears',
          label: 'Max',
          class: 'text-center'
        },
        {
          key: 'AvgYears',
          label: 'Avg',
          class: 'border-right text-center',
          formatter: function (value, key, item) {
            return (Math.round((Number(value) + Number.EPSILON) * 100) / 100).toFixed(2)
          }
        },
        {
          key: 'CubScouting',
          label: 'Cub Scouting',
          class: 'text-center'
        },
        {
          key: 'ScoutsBSA',
          label: 'Scouts BSA',
          class: 'text-center'
        },
        {
          key: 'Venturing',
          label: 'Venturing',
          class: 'text-center'
        },
        {
          key: 'SeaScouting',
          label: 'Sea Scouts',
          class: 'text-center'
        },
        {
          key: 'Exploring',
          label: 'Exploring',
          class: 'text-center'
        },
        {
          key: 'District',
          label: 'District',
          class: 'text-center'
        },
        {
          key: 'Council',
          label: 'Council',
          class: 'text-center'
        },
        {
          key: 'Other',
          label: 'Other',
          class: 'text-center'
        }
      ]
    }
  },
  created () {
    this.critters = crittersService.getCritters()
  },
  mounted () {
    patrolApi.getAssignments(this.$root.courseKey)
      .then(x => {
        this.rawInfo = x
        this.rowData = x.Assignments
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    assign: function (row) {
      this.critterUpdate = row
      this.showEdit = true
    },
    save: function () {
      return this.$refs.form.validate().then(res => {
        if (res) {
          this.updatePatrolAssignment(this.critterUpdate.Critter, this.critterUpdate.ScouterKey)
          this.showEdit = false
        }
        return res
      })
    },
    rowStyle: function (rowItem) {
      if (rowItem.row.CritterName === 'Course') {
        return 'font-weight-bold'
      } else {
        return ''
      }
    },
    avgFormatter: function (row, column, cellValue, index) {
      if (isNaN(cellValue)) {
        return '--'
      } else {
        return Number(cellValue).toFixed(2)
      }
    },
    sortPatrol: function (a, b) {
      const sorting = { a: a, b: b }
      this.tempHolding.push(sorting)
      // equal items sort equally
      if (a.Critter === b.Critter) {
        return 0
      } else if (a.Critter === null) {
        // nulls sort after anything else
        return 1
      } else if (b.Critter === null) {
        // nulls sort after anything else
        return -1
      }
      // otherwise, if we're ascending, lowest sorts first
      return a.Critter < b.Critter ? -1 : 1
    },
    updatePatrolAssignment (newPatrol, scouterKey) {
      if (newPatrol !== '') {
        patrolApi.updatePatrolAssignment(this.$root.courseKey, scouterKey, newPatrol)
          .then(x => {
            this.rawInfo = x
            this.rowData = x.Assignments
            this.$notify({
              message: 'The patrol assignment is complete.',
              icon: 'nc-icon nc-satisfied',
              type: 'success',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error updating the patrol.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        patrolApi.removePatrolAssignment(this.$root.courseKey, scouterKey)
          .then(x => {
            this.rawInfo = x
            this.rowData = x.Assignments
            this.$notify({
              message: 'The patrol un-assignment is complete.',
              icon: 'nc-icon nc-satisfied',
              type: 'success',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error removing this participant from this patrol.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
